export const enum OsciloEstadoTipoEnum {
    NoInicializado = 0,
    Funcionando = 1,
    Standby = 2,
    SucesoNuevo = 3,
    SucesoReciente = 4,
    SucesoAntiguo = 5,
    Error = 6
}